import { render, staticRenderFns } from "./PromoCodePaymentMethods.vue?vue&type=template&id=5251f6e4&"
import script from "./PromoCodePaymentMethods.vue?vue&type=script&lang=js&"
export * from "./PromoCodePaymentMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports